import type { SVGProps } from 'react';

const SvgTypeSpecimen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M4 6H2v16h16v-2H4z" />
    <path d="M22 2H6v16h16zm-5.37 12.5-.8-2.3H12.2l-.82 2.3H9.81l3.38-9h1.61l3.38 9z" />
    <path d="m13.96 7.17-1.31 3.72h2.69l-1.3-3.72z" />
  </svg>
);
export default SvgTypeSpecimen;
